const adjectives: string[] = [
  "Absorbing",
  "Adorable",
  "Adventurous",
  "Aesthetic",
  "Agile",
  "Alluring",
  "Amiable",
  "Angry",
  "Awesome",
  "Awkward",
  "Beautiful",
  "Benevolent",
  "Blissful",
  "Bold",
  "Bountiful",
  "Breathtaking",
  "Brave",
  "Brilliant",
  "Captivating",
  "Candid",
  "Chaotic",
  "Charming",
  "Cherished",
  "Clever",
  "Clumsy",
  "Confident",
  "Creative",
  "Crisp",
  "Curious",
  "Curvaceous",
  "Cuddly",
  "Dauntless",
  "Dazzling",
  "Delightful",
  "Devoted",
  "Dreamy",
  "Dull",
  "Dynamic",
  "Ebullient",
  "Effervescent",
  "Effortless",
  "Effulgent",
  "Elegant",
  "Empathetic",
  "Enchanting",
  "Energetic",
  "Enthusiastic",
  "Excited",
  "Exquisite",
  "Fanciful",
  "Fantastic",
  "Fascinating",
  "Festive",
  "Fiery",
  "Flawless",
  "Flourishing",
  "Foolish",
  "Fragrant",
  "Fulfilled",
  "Generous",
  "Gentle",
  "Gleaming",
  "Glistening",
  "Gloomy",
  "Glowing",
  "Gorgeous",
  "Graceful",
  "Gracious",
  "Grandiose",
  "Gritty",
  "Handsome",
  "Happy",
  "Hardy",
  "Harmonious",
  "Heartwarming",
  "Heavenly",
  "Hopeful",
  "Humble",
  "Hypnotic",
  "Illuminated",
  "Incredible",
  "Indifferent",
  "Inspired",
  "Inspiring",
  "Inventive",
  "Invigorating",
  "Irreplaceable",
  "Irresistible",
  "Jazzy",
  "Jovial",
  "Joyful",
  "Jubilant",
  "Judicious",
  "Juxtaposed",
  "Kaleidoscopic",
  "Keen",
  "Keen-eyed",
  "Kissable",
  "Knowledgeable",
  "Kooky",
  "Laughing",
  "Lazy",
  "Lively",
  "Lucid",
  "Luminous",
  "Lustrous",
  "Magnetic",
  "Magnificent",
  "Majestic",
  "Mellifluous",
  "Merry",
  "Mesmerizing",
  "Meticulous",
  "Mysterious",
  "Mystical",
  "Nervous",
  "Nimble",
  "Noble",
  "Nostalgic",
  "Nuanced",
  "Nurtured",
  "Nurturing",
  "Observant",
  "Optimistic",
  "Opulent",
  "Ornamental",
  "Ornate",
  "Outstanding",
  "Overjoyed",
  "Overflowing",
  "Passionate",
  "Peaceful",
  "Picturesque",
  "Playful",
  "Pleasurable",
  "Poised",
  "Pragmatic",
  "Pristine",
  "Quaint",
  "Quaking",
  "Quirky",
  "Quizzical",
  "Radiant",
  "Radiating",
  "Regal",
  "Resilient",
  "Resplendent",
  "Robust",
  "Sad",
  "Selfish",
  "Serene",
  "Serendipitous",
  "Sincere",
  "Spectacular",
  "Spirited",
  "Stunning",
  "Subtle",
  "Sunny",
  "Tantalizing",
  "Tender",
  "Tenacious",
  "Terrific",
  "Thrilling",
  "Thoughtful",
  "Timid",
  "Transcendent",
  "Transparent",
  "Tranquil",
  "Tumultuous",
  "Unassumed",
  "Unforgettable",
  "Unique",
  "Unorthodox",
  "Unwavering",
  "Unyielding",
  "Uplifting",
  "Utopian",
  "Valiant",
  "Versatile",
  "Vibrant",
  "Vivacious",
  "Vivid",
  "Warmhearted",
  "Whimsical",
  "Whispering",
  "Wholesome",
  "Wild",
  "Winsome",
  "Wise",
  "Witty",
  "Wonderful",
  "Wondrous",
  "Zany",
  "Zestful",
  "Zesty",
];

export default adjectives;
